import { render, staticRenderFns } from "./ModalUserDetail.vue?vue&type=template&id=0164cbf7&scoped=true&"
import script from "./ModalUserDetail.vue?vue&type=script&lang=js&"
export * from "./ModalUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserDetail.vue?vue&type=style&index=0&id=0164cbf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164cbf7",
  null
  
)

export default component.exports